import { IconAt, IconPhone, IconSun } from '@tabler/icons-react';
import { Box, Stack, Text } from '@mantine/core';
import classes from './ContactIcons.module.css';

interface ContactIconProps extends Omit<React.ComponentPropsWithoutRef<'div'>, 'title'> {
  icon: typeof IconSun;
  title: React.ReactNode;
  description: React.ReactNode;
}

function ContactIcon({ icon: Icon, title, description, ...others }: ContactIconProps) {
  return (
    <div className={classes.wrapper} {...others}>
      <Box mr="md">
        <Icon size={24} />
      </Box>

      <div>
        <Text size="xs" className={classes.title}>
          {title}
        </Text>
        {Array.isArray(description) ? (
          description.map((item, index) => (
            <Text key={index} className={classes.description}>
              {item}
            </Text>
          ))
        ) : (
          <Text className={classes.description}>{description}</Text>
        )}
      </div>
    </div>
  );
}

const MOCKDATA = [
  { title: 'Correo', description: 'unoyunosoluciones@gmail.com', icon: IconAt },
  { title: 'Teléfono: Monterrey, NL', description: '81-3892-4955', icon: IconPhone },
  { title: 'Teléfono: Mérida, Yuc', description: '984-555-9929', icon: IconPhone },
];


export function ContactIconsList() {
  const items = MOCKDATA.map((item, index) => <ContactIcon key={index} {...item} />);
  return <Stack>{items}</Stack>;
}
